export class ApproverFormData {
  username: string | undefined;
  uidNumber: string | undefined;
  deputyUsername: string | undefined;
  deputyUidNumber: string | undefined;
  limit: number | undefined;
  groupMember: ApproverFormData[] | undefined;
  mailNotification: boolean | undefined;
  forInformationOnly: boolean | undefined;

  constructor(username: string | undefined, uidNumber: string | undefined, deputyUsername: string | undefined, deputyUidNumber: string | undefined, limit: number | undefined, groupMember: ApproverFormData[] | undefined, mailNotification: boolean | undefined, forInformationOnly: boolean | undefined) {
    this.username = username;
    this.uidNumber = uidNumber;
    this.deputyUsername = deputyUsername;
    this.deputyUidNumber = deputyUidNumber;
    this.limit = limit;
    this.groupMember = groupMember;
    this.mailNotification = mailNotification;
    this.forInformationOnly = forInformationOnly;
  }
}
